module.exports = __webpack_public_path__ + "btn-appStore.svg?78c28885d90638acd3841fae79f70070";


//////////////////
// WEBPACK FOOTER
// ./src/assets/btn-appStore.svg
// module id = 40
// module chunks = 0